import { useNavigate } from "react-router-dom";
import Nav from "@/components/Nav";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="grain min-h-screen bg-[#050505] text-white">
      <Nav />
      <div className="mx-auto flex min-h-[calc(100vh-73px)] max-w-2xl flex-col items-start justify-center px-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#FF3333]">/ TRANSACTION · ABORTED</div>
        <XCircle className="mt-4 h-12 w-12 text-[#FF3333]" strokeWidth={1.5} />
        <h1 className="mt-4 font-display text-5xl font-medium tracking-tighter">Checkout cancelled.</h1>
        <p className="mt-4 text-zinc-400">No charge was made. Your exposure remains as-is until you upgrade.</p>
        <Button data-testid="cancel-cta" onClick={() => nav("/pricing")}
          className="btn-cta mt-10 h-12 rounded-none border border-[#E5FF00] bg-[#E5FF00] px-8 font-mono text-[11px] uppercase tracking-[0.25em] text-black hover:bg-transparent hover:text-[#E5FF00]">
          Back to Pricing →
        </Button>
      </div>
    </div>
  );
}
